import { motion } from "framer-motion";

export const MarqueeText = () => {
  const text = "DIREITO TRIBUTÁRIO • PLANEJAMENTO FISCAL • REFORMA TRIBUTÁRIA 2026 • RECUPERAÇÃO DE CRÉDITOS • DEFESA FISCAL • ";

  return (
    <section className="py-8 bg-primary overflow-hidden">
      <div className="flex whitespace-nowrap">
        <motion.div
          animate={{ x: "-50%" }}
          transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
          className="flex"
        >
          {[...Array(4)].map((_, i) => (
            <span
              key={i}
              className="font-display text-xl lg:text-2xl text-accent-foreground tracking-widest mx-8"
            >
              {text}
            </span>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
